import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    updateCustomerDetails : [],
    loading : false,
    error : null,
};

const updateCustomerSlice = createSlice({
    name:"updateCustomerDetails",
    initialState,
    reducers: {
        fetchUpdateCustomerDetailsSuccess: (state,action) => {
            state.loading = false;
            state.updateCustomerDetails = action.payload
        },
        fetchUpdateCustomerDetailsFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    }
})

export const {
    fetchUpdateCustomerDetailsFailure,
    fetchUpdateCustomerDetailsSuccess
} = updateCustomerSlice.actions

export default updateCustomerSlice.reducer